export default __webpack_public_path__ + "static/media/icon-video-consult_white.096eb9ed.svg";